<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="750px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="mini" label-width="80px" class="content">
      <el-row>
        <el-col :span="12">
          <el-form-item label="质检条目" prop="checkCategory">
            <el-input v-model.trim="addForm.checkCategory" disabled maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="违规项" prop="categoryDetail">
            <el-input v-model.trim="addForm.categoryDetail" disabled maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="场景" prop="scene">
            <el-input v-model.trim="addForm.scene" maxlength="100" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="扣分" prop="assessmentScore">
            <el-input v-model.trim="addForm.assessmentScore" maxlength="100" @input="buyPriceInput(addForm, 'assessmentScore')" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-radio v-model="addForm.status" label="启用">启用</el-radio>
            <el-radio v-model="addForm.status" label="禁用">禁用</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生效时间" prop="effectDate">
            <el-date-picker
              v-model="addForm.effectDate"
              type="date"
              value-format="yyyyMMdd"
              placeholder="年/月/日"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否通报" prop="isReport">
            <el-radio-group v-model="addForm.isReport" @input="isReportChange">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="通报时长" prop="reportDuration">
            <el-input v-model="addForm.reportDuration" @input="sortNumInput" />
            <span style="margin-left: 5px">天</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="说明" prop="describe">
            <el-input v-model="addForm.describe" type="textarea" :rows="3" placeholder="请输入描述信息"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    // refundReasonList: {
    //   type: Array,
    //   default: [],
    // },
    rowData: Object,
  },
  data() {
    return {
      addForm: {
        reportDuration: ''
      },
      userId: "",
      userList: [],
      all: false,
      rules: {
        checkCategory: [{ required: true, message: "不能为空", trigger: "blur" }],
        categoryDetail: [{ required: true, message: "不能为空", trigger: "blur" }],
        scene: [{ required: true, message: "不能为空", trigger: "blur" }],
        assessmentScore: [{ required: true, message: "不能为空", trigger: "blur" }],
        effectDate: [{ required: true, message: "不能为空", trigger: "change" }],
        reportDuration: [{ required: false, message: "不能为空", trigger: "blur" }],
      },
      loading: false,
      loadingButtom: false,
      authOptions: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "编辑";
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      addForm.effectDate = addForm.effectDate + ''
      this.addForm = addForm;
      this.$set(this.addForm,'reportDuration', addForm.reportDuration ? parseInt(addForm.reportDuration) : '')
      this.isReportChange(addForm.isReport)
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        let data = {
          ...this.addForm,
          isReport: this.addForm.isReport == '是' ? 1 : 0
        }
        this.$q.qualityTestingManage
          .projectConfigUpdate({ data: data })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("编辑成功");
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    isReportChange(val) {
      if(val == '是') {
        this.rules.reportDuration[0].required = true;
      }else{
        this.rules.reportDuration[0].required = false;
        this.$set(this.addForm, 'reportDuration', '')
        this.$refs.addForm.clearValidate('reportDuration');
      }
    },

    sortNumInput(val) {
      // 只允许输入正整数（非0），去除非数字和前导0
      let num = val.replace(/[^\d]/g, '');
      num = num.replace(/^0+/, '');
      this.addForm.reportDuration = num;
    },
    //只能输入正数并小数点保留1位
    buyPriceInput(item, name) {
      var price = "" + item[name];
      price = price
        .replace(/[^\d.]/g, "") // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, ".") // 只保留第一个. 清除多余的
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3"); // 只能输入两个小数
      if (price.indexOf(".") < 0 && price != "") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        price = parseFloat(price);
      }
      item[name] = price;
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 240px !important
>>> .el-input
  width 240px !important
>>> .el-input-number--mini 
  width: 240px !important;

>>> .el-row 
  display flex
  flex-wrap wrap
</style>
